import * as React from 'react'
import { FormInputTime } from '@hyper/forms/form-input-time'

export const TechnicalOrderWorkTimeModalForm: React.FC = () => (
  <FormInputTime label="Czas pracy" name="custom_total_working_time" withSeconds={true} />
)
